<template>
    <div class="homeAround-content">
        <!-- <div class="temporary-ele" @click="goToPage('https://cam2025.contrimetric.com/')">
            <div style="padding: 30px 0 0 0;">2025 Contrimetric Annual Meeting: Al & New Metrics<span style="color:#F4B54E;"> Call for Abstracts</span></div>
            <div style="padding: 10px 0 30px 0;"><img src="@/assets/images/home/temporary_icon.png" alt=""></div>
        </div> -->

        <div class="around_list">
            <div class="around_item">
                <div class="around_iamge">
                    <img src="../assets/images/home/about_contrimetric.png" alt="">
                </div>

                <div class="item_text_box">
                    <div class="item_title">About Contrimetric</div>
                    <div class="item_sub_title">Reimagining the metrics of scholarly excellence</div>
                    <div class="item_desc">At Contrimetric, we are redefining how the world evaluates academic impact.
                        In an
                        age of information overload and citation inflation, we bring clarity, depth, and precision to
                        research assessment empowering scholars, institutions, and publishers to see beyond numbers and
                        into
                        meaningful contribution.</div>
                </div>

            </div>

            <div class="around_item around_reverse">

                <div class="item_text_box">
                    <div class="item_title">Our vision</div>
                    <div class="item_sub_title">Metrics that matter, impact that resonates</div>
                    <div class="item_desc">We envision a scholarly ecosystem where true research value isn’t lost in
                        averages or skewed by prestige. Contrimetric exists to surface the intrinsic merit of individual
                        work and spotlight the unsung paper, the emerging researcher, the breakthrough idea hiding in
                        plain sight.
                    </div>
                </div>
                <div class="around_iamge">
                    <img src="../assets/images/home/our_vision.png" alt="">
                </div>
            </div>

            <div class="around_item">
                <div class="around_iamge">
                    <img src="../assets/images/home/Contrimetric banner 3.png" alt="">
                </div>
                <div class="item_text_box">
                    <div class="item_title">Our distinguished innovation</div>
                    <div class="item_sub_title">The Article Citation Contribution Indicator (ACCI)</div>
                    <div class="item_desc_title">A New Standard for Paper-Level Impact</div>
                    <div class="item_desc">Known as Contrimetric, the ACCI is our pioneering bibliometric indicator that
                        measures an article’s impact in relation to its journal’s performance. Rather than comparing
                        papers
                        across disciplines or relying on journal-wide metrics, ACCI aims to offer a nuanced, fairer, and
                        more accurate evaluation.</div>
                    <div class="item_parts">
                        <div class="item_part1">
                            <div class="item_part_point"></div>
                            <div>Applicable for leading journals</div>
                        </div>
                        <div class="item_part2">
                            <div class="item_part_point"></div>
                            <div>Recognized for its academic rigor and transformative potential</div>
                        </div>
                        <div class="item_part3">
                            <div class="item_part_point"></div>
                            <div>Designed for both researchers and research evaluators</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="around_item around_reverse">
                <div class="item_text_box">
                    <div class="item_title">Our smart tools</div>
                    <div class="item_sub_title">Automated plug-in</div>
                    <div class="item_desc">More than a citation counter, our AI-powered plug-in is your intelligent
                        research
                        companion. It delivers personalized citation data, recommends relevant literature, and enhances
                        academic visibility — all in real time. Whether you're drafting, reviewing, or exploring,
                        Contrimetric meets you where your curiosity begins.</div>
                    <div class="item_parts">
                        <div class="item_part1">
                            <div class="item_part_point"></div>
                            <div>Free to use, powerful in scope</div>
                        </div>
                        <div class="item_part2">
                            <div class="item_part_point"></div>
                            <div> Intuitively integrates with your research workflow </div>
                        </div>
                        <div class="item_part3">
                            <div class="item_part_point"></div>
                            <div> Enhances discoverability and scholarly connection</div>
                        </div>
                    </div>
                </div>
                <div class="around_iamge">
                    <img src="../assets/images/home/Contrimetric banner 4.png" alt="">
                </div>
            </div>
        </div>


        <div class="box_1">
            <div class="box_11">
                <img :src="require('@/assets/images/index_widget.png')" alt="">
            </div>
        </div>
        <div class="box_3">
            <div class="box_3_list">
                <div class="around_item">
                    <div class="around_iamge">
                        <img src="../assets/images/home/Contrimetric banner 5.png" alt="">
                    </div>
                    <div class="item_text_box">
                        <div class="item_title">Our reach</div>
                        <div class="item_sub_title">Transforming platforms, empowering authors</div>
                        <div class="item_desc">From international journals to institutional repositories, Contrimetric
                            is
                            already reshaping how academic platforms operate. Our technology enriches the publishing
                            experience
                            and is enabling real-time impact tracking, intelligent reading pathways, and author
                            empowerment
                            through dynamic citation insights.</div>
                    </div>

                </div>

                <div class="around_item around_reverse" style="margin-bottom: 1rem;">
                    <div class="item_text_box">
                        <div class="item_title">Join the movement</div>
                        <div class="item_sub_title">Let’s reimagine research impact</div>
                        <div class="item_desc">We’re building a future where every citation tells a story, and every
                            paper
                            finds
                            its place. If you're a researcher, editor, or institution seeking to enhance transparency,
                            recognition, and integrity in research evaluation, Contrimetric invites you to collaborate.
                        </div>
                    </div>
                    <div class="around_iamge">
                        <img src="../assets/images/home/Contrimetric banner 8.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: { 
        goToPage(url){
            window.open(url, '_blank')
        }
    },
}
</script>

<style lang='scss' scoped>
@import "../assets/css/minix.scss";

.homeAround-content {
    margin-top: -42px;
    width: 100%;
    background-image: url('../assets/images/home/home_container_bg.png');
    background-color: #fff;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: 48px 48px 0px 0px;
}


.temporary-ele{
    margin: 120px auto;
    background-image: url('../assets/images/home/home_temporary.png');
    background-color: #fff;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    &:hover{
        cursor: pointer;
    }
    >div{
        width: 1200px;
        margin: 0 auto;
        text-align: center;
        font-size: 22px;
    }
}
.box_1 {
    width: 100%;
    padding: 100px 0;
    margin: 40px 0px 60px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url('../assets/images/home/box_1_bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.box_11 {
    display: flex;
    justify-content: center;
    align-items: center;
}

.box_11>img {
    width: 75%;
}



.around_list {
    width: 100%;
    @include responsive-width(1200px);
    margin: 0 auto;



    .storng_text {
        font-weight: bold;
    }
}

.box_3 {
    width: 100%;
    background-image: url('../assets/images/home/home_container_bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.box_3_list {
    @include responsive-width(1200px);
    margin: 0 auto;
}


.around_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1.5;
    margin: 4em 0;
    gap: 20px;

    .item_text_box {
        flex: 0 0 48%;

        .item_title,
        .item_desc,
        .item_parts {
            font-size: 16px;
        }

        .item_title {
            font-size: 30px;
            font-weight: bold;
            line-height: 1.36;
            color: black;
        }

        .item_sub_title {
            font-size: 20px;
            font-weight: bold;
            margin-top: 6px;
        }

        .item_desc_title {
            margin-top: 6px;
            font-style: italic;
        }

        .item_desc {
            margin: 20px 0;
        }

        .item_parts {
            .item_part_point {
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background-color: black;
            }

            .item_part1,
            .item_part2,
            .item_part3 {
                display: flex;
                align-items: baseline;
                margin-bottom: 10px;

                div {
                    margin-left: 14px;
                }
            }

            .item_part1 {
                margin-bottom: 10px;
            }

            div {
                position: relative;

                i {
                    background-color: #e1f8fa;
                    padding: 4px;
                    border-radius: 50%;
                    color: #1da6b8;
                }
            }
        }
    }

    .around_iamge {
        width: 100%;

        img {
            width: 85%;
        }
    }
}


@media (max-width: 768px) {
    .around_list {
        .around_item {
            flex-direction: column;
            margin: 4em 0;

            .item_text_box {
                .item_title {
                    font-size: 24px;
                }
            }

            .around_iamge {
                text-align: center;

                img {
                    width: 70%;
                }
            }
        }

        .around_reverse {
            flex-direction: column-reverse;
        }
    }

    .box_3_list {
        .around_item {
            flex-direction: column;

            .around_iamge {
                text-align: center;
            }
        }

        .around_reverse {
            display: flex;
            flex-direction: column-reverse;
        }
    }
}
</style>